import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { TEAMS, isVideo } from "../lib/site";

export default function Equipes() {
  return (
    <>
      <SEO title="Nos Équipes" description="Équipe féminine, Équipe Homme N3, École de Vélo et Loisir & Cyclo : le Club Cycliste Le Boulou, un club pour tous les cyclistes." />
      <PageHeader kicker="Nos Équipes" title="Un club, pour tous les cyclistes" />

      <section className="py-20 sm:py-28">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {Object.values(TEAMS).map((team, i) => (
            <Reveal key={team.slug} delay={i * 0.1}>
              <Link
                to={`/equipes/${team.slug}`}
                data-testid={`equipes-card-${team.slug}`}
                className="group relative block overflow-hidden h-[420px]"
              >
                {isVideo(team.image) ? (
                  <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{ objectPosition: team.position }}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  >
                    <source src={team.image} type="video/mp4" />
                    <source src={team.image.replace(/\.mp4$/i, ".webm")} type="video/webm" />
                  </video>
                ) : (
                  <img
                    src={team.image}
                    alt={team.name}
                    loading="lazy"
                    style={{ objectPosition: team.position }}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  {team.sponsor && (
                    <p className="text-rouge text-xs font-bold uppercase tracking-[0.25em] mb-2">{team.sponsor}</p>
                  )}
                  <h2 className="font-heading uppercase font-semibold tracking-tight text-white text-2xl">{team.name}</h2>
                  <span className="mt-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-white/80 group-hover:text-rouge transition-colors duration-300">
                    Découvrir <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
